import LabsDemoModeSelectPage from './LabsDemoModeSelect';

export default function DemoModeSelectPage() {
  return <LabsDemoModeSelectPage />;
}
